module.exports = __webpack_public_path__ + "img/file-doc.e15dfecb.svg";